import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const AnesthesiaAndIntensiveCareIcon = React.memo(
  ({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(height)}
      viewBox={viewBox}
    >
      <path
        fill={variables['colors-mc-primary']}
        fillOpacity='0.1'
        stroke={variables['colors-mc-primary']}
        d='M79.6426 40C79.6426 61.8153 61.9578 79.5 40.1426 79.5C18.3273 79.5 0.642578 61.8153 0.642578 40C0.642578 18.1848 18.3273 0.5 40.1426 0.5C61.9578 0.5 79.6426 18.1848 79.6426 40Z'
      />
      <path d='M30.1147 59.3469H41.5902V65.0002H30.1147V59.3469Z' fill='#EEB9AD' />
      <path
        d='M50.8098 46.8418C53.2943 44.3016 54.7049 40.8762 54.7049 37.2869V34.8656C54.7049 33.6598 54.4246 32.4713 53.8852 31.3934L53.559 26.5041C53.2738 22.218 49.9574 18.7533 45.6885 18.2787L44.8639 17.7287C42.1959 15.9492 39.0598 15 35.8525 15C32.6451 15 29.509 15.9492 26.841 17.7287L26.0164 18.2787C21.7475 18.7533 18.4311 22.218 18.1459 26.5041L17.8197 31.3934C17.2803 32.4713 17 33.6607 17 34.8656V37.2869C17 40.8762 18.4107 44.3016 20.8951 46.8426'
        fill='#50BAE3'
      />
      <path
        d='M50.8098 46.8418C53.2942 44.3016 54.7049 40.8762 54.7049 37.2869V34.8656C54.7049 33.6606 54.4246 32.4713 53.8852 31.3934L53.559 26.5041C53.2737 22.218 49.9573 18.7533 45.6885 18.2787L44.8639 17.7287C44.2401 17.3131 43.5893 16.9467 42.9196 16.6229C41.4311 16.1811 39.8811 15.9451 38.3114 15.9451C35.1041 15.9451 31.968 16.8942 29.3 18.6738L28.4754 19.2238C24.2065 19.6983 20.8901 23.1631 20.6049 27.4492L20.2787 32.3385C19.7393 33.4164 19.459 34.6057 19.459 35.8106V38.232C19.459 41.3943 20.5565 44.4279 22.5155 46.8426L50.8098 46.8418Z'
        fill='#6EC5E7'
      />
      <path
        d='M39.1315 27.9622H37.4921V27.295C37.4921 25.1639 37.3143 23.018 36.9643 20.9171L36.6831 19.2335L38.3003 18.9639L38.5815 20.6475C38.9462 22.8376 39.1315 25.0737 39.1315 27.295V27.9622Z'
        fill='#4197CD'
      />
      <path
        d='M34.8508 28.4425L34.0754 27.3368C33.0934 25.863 32.5737 24.1483 32.5737 22.377H34.2131C34.2131 23.8237 34.6377 25.2237 35.4393 26.427L36.1795 27.4819L34.8508 28.4425Z'
        fill='#4197CD'
      />
      <path
        d='M21.9034 33.3376L21.6477 33.0351C20.7567 31.8884 20.2788 30.4917 20.2788 29.0745V28.9343H21.9182V29.0745C21.9182 30.1302 22.2747 31.1696 22.9206 32.0032L23.1542 32.2778L21.9034 33.3376Z'
        fill='#4197CD'
      />
      <path
        d='M54.2641 32.2985C54.1559 31.9903 54.0321 31.687 53.8854 31.3935L53.7887 29.9419L53.2034 30.9386L52.928 31.3517C52.319 32.2648 51.3452 32.8673 50.2444 33.005L49.1133 33.1632L49.3403 34.7862L50.4592 34.6296C52.0067 34.437 53.3887 33.587 54.2641 32.2985Z'
        fill='#4197CD'
      />
      <path
        d='M47.4287 51.1665C50.4705 48.5763 52.2459 44.7698 52.2459 40.7361C52.2459 33.3124 46.2287 27.2952 38.8049 27.2952H32.8991C25.4762 27.2952 19.459 33.3124 19.459 40.7361C19.459 44.7935 21.2557 48.6214 24.3295 51.2124'
        fill='#92E0F7'
      />
      <path
        d='M35.8524 30.5737C42.186 30.5737 47.7794 34.7049 49.6417 40.7582L49.7868 41.2295L48.145 48.6172C47.0917 53.3557 44.3024 57.5278 40.3262 60.3114C39.0147 61.2286 37.4532 61.7213 35.8524 61.7213C34.2516 61.7213 32.6901 61.2286 31.3786 60.3114C27.4024 57.5278 24.6122 53.3557 23.5598 48.6172L21.918 41.2295L22.0631 40.7582C23.9253 34.7049 29.5188 30.5737 35.8524 30.5737Z'
        fill='#EEB9AD'
      />
      <path
        d='M33.0183 60.3115C34.1035 61.0714 35.3634 61.5197 36.6724 61.6591C37.9806 61.5205 39.2412 61.0714 40.3265 60.3115C44.3027 57.5279 47.0929 53.3558 48.1453 48.6173L49.7871 41.2296L49.642 40.7582C47.8601 34.9681 42.6634 30.9468 36.6724 30.6074C30.6814 30.9468 25.4847 34.9681 23.7027 40.7582L23.5576 41.2296L25.1994 48.6173C26.2519 53.3558 29.042 57.5279 33.0183 60.3115Z'
        fill='#FFE2D5'
      />
      <path
        d='M41.5902 43.6887C40.2665 43.6887 39.0763 42.9534 38.4845 41.769L38.3984 41.5969L39.8648 40.8633L39.9509 41.0362C40.2632 41.6608 40.8911 42.0493 41.5902 42.0493C42.2894 42.0493 42.9173 41.6608 43.2296 41.0362L43.3156 40.8633L44.782 41.5969L44.696 41.7698C44.1042 42.9534 42.914 43.6887 41.5902 43.6887Z'
        fill='#EEB9AD'
      />
      <path
        d='M30.1151 43.6887C28.7914 43.6887 27.6012 42.9534 27.0094 41.769L26.9233 41.5969L28.3897 40.8633L28.4758 41.0362C28.7881 41.6608 29.416 42.0493 30.1151 42.0493C30.8143 42.0493 31.4422 41.6608 31.7545 41.0362L31.8406 40.8633L33.3069 41.5969L33.2209 41.7698C32.6291 42.9534 31.4389 43.6887 30.1151 43.6887Z'
        fill='#EEB9AD'
      />
      <path
        d='M40.326 61.1313C39.0146 62.0485 37.4531 62.5411 35.8523 62.5411C34.3982 62.5411 32.9851 62.1157 31.7539 61.3526C31.7539 63.3665 33.3867 65.0001 35.4014 65.0001H41.59V60.155C41.1818 60.4944 40.7637 60.8247 40.326 61.1313Z'
        fill='#FFE2D5'
      />
      <path
        d='M44.0492 52.7049V50.9246C44.0492 49.6443 43.0115 48.6066 41.7312 48.6066C41.1164 48.6066 40.5263 48.3623 40.0918 47.9279L38.6517 46.4877C37.909 45.7451 36.9025 45.3279 35.8525 45.3279C34.8025 45.3279 33.7959 45.7451 33.0541 46.4869L31.614 47.9271C31.1795 48.3615 30.5894 48.6058 29.9746 48.6058C28.6935 48.6066 27.6558 49.6443 27.6558 50.9246V53.9459C27.6558 56.3 28.591 58.5574 30.2558 60.2221C31.7402 61.7074 33.7533 62.541 35.8525 62.541C37.9517 62.541 39.9648 61.7074 41.4492 60.223C42.6246 59.0476 43.4361 57.5762 43.8123 55.9844L44.0492 52.7049Z'
        fill='#6BAA93'
      />
      <path
        d='M44.049 52.7049V50.9246C44.049 49.6443 43.0113 48.6066 41.731 48.6066C41.1162 48.6066 40.5261 48.3623 40.0916 47.9279L38.6515 46.4877C37.9089 45.7451 36.9023 45.3279 35.8523 45.3279C34.8023 45.3279 33.7957 45.7451 33.0539 46.4869L31.6138 47.9271C31.1793 48.3615 30.5892 48.6058 29.9744 48.6058C29.931 48.6058 29.8908 48.6164 29.8482 48.6189C29.508 49.023 29.2949 49.5369 29.2949 50.1049V53.1262C29.2949 55.4803 30.2302 57.7377 31.8949 59.4025C33.3793 60.8877 35.3925 61.7213 37.4916 61.7213C38.431 61.7213 39.3498 61.5459 40.2154 61.2279C40.6564 60.9369 41.0703 60.6017 41.4498 60.2221C42.6252 59.0467 43.4367 57.5754 43.813 55.9828L44.049 52.7049Z'
        fill='#8BC6AE'
      />
      <path
        d='M35.8524 57.6231C37.6632 57.6231 39.1311 56.1551 39.1311 54.3444C39.1311 52.5336 37.6632 51.0657 35.8524 51.0657C34.0416 51.0657 32.5737 52.5336 32.5737 54.3444C32.5737 56.1551 34.0416 57.6231 35.8524 57.6231Z'
        fill='#559580'
      />
      <path
        d='M57.9835 64.9999L51.2852 58.3016C49.8007 56.8171 47.7876 55.9835 45.6885 55.9835H36.6721C35.7663 55.9835 35.0327 55.2499 35.0327 54.3442C35.0327 53.4384 35.7663 52.7048 36.6721 52.7048H45.6885C48.8376 52.7048 51.8573 53.9557 54.0844 56.1827L62.9016 64.9999'
        fill='#BEE2DC'
      />
    </svg>
  )
);
AnesthesiaAndIntensiveCareIcon.displayName = 'AnesthesiaAndIntensiveCareIcon';

export default AnesthesiaAndIntensiveCareIcon;
